import { ensure, stringType, TType } from "types";

import { ICodelist } from "@/data/codelists";

export interface TPhoneCodeCodelistParameter {
  format: string;
}

export interface IPhone {
  phoneCode: ICodelist["code"] | null;
  phoneNumber: string;
  phonePrefix: string;
}

export const configPhoneType: TType<IPhone> = {
  phoneCode: stringType(null),
  phoneNumber: stringType(""),
  phonePrefix: stringType(""),
};

export const phoneType = ensure(configPhoneType);
